import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, ButtonBase, Collapse, Typography } from '@mui/material';
import React from 'react';
import { BLUE, INTER, NAVY, SURFACE_SOFT } from '../../studentStyles';

// Teacher-authored notes (legacy new_word_info_text / word_info_text popover),
// tucked behind an expandable row like the other optional details.
export default function InfoExpander({ text, label = 'More info' }: { text: string; label?: string }) {
    const [open, setOpen] = React.useState(false);
    return (
        <Box sx={{ mt: 1.5 }}>
            <ButtonBase
                onClick={() => setOpen(prev => !prev)}
                aria-expanded={open}
                sx={{ minHeight: 44, borderRadius: '999px', px: 1.25, py: 0.5, gap: 0.5, fontFamily: INTER, fontWeight: 700, fontSize: 13, color: BLUE }}
            >
                <InfoOutlinedIcon sx={{ fontSize: 17 }} />
                {label}
                <ExpandMoreRoundedIcon sx={{ fontSize: 18, transform: open ? 'rotate(180deg)' : 'none', transition: 'transform 200ms ease' }} />
            </ButtonBase>
            <Collapse in={open}>
                <Typography sx={{ mt: 1, p: 1.5, borderRadius: '12px', backgroundColor: SURFACE_SOFT, fontFamily: INTER, fontSize: 13, color: NAVY, lineHeight: 1.5, textAlign: 'left' }}>
                    {text}
                </Typography>
            </Collapse>
        </Box>
    );
}
